(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var box = document.querySelector('[data-cart-discount]');
    if (!box) return;

    var input = box.querySelector('[data-cart-discount-input]');
    var applyButton = box.querySelector('[data-cart-discount-apply]');
    var message = box.querySelector('[data-cart-discount-message]');
    var list = box.querySelector('[data-cart-discount-codes]');

    box.hidden = false;

    function say(text) {
      message.textContent = text || '';
      message.hidden = !text;
    }

    function currentCodes() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          return cart.discount_codes || [];
        });
    }

    /* The documented way to set a cart's codes: the whole list, comma
       separated. An empty string removes them all. */
    function setCodes(codes) {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: codes.join(',') })
      }).then(function (response) {
        if (!response.ok) throw new Error('update failed');
        return response.json();
      });
    }

    function busy(on) {
      applyButton.disabled = on;
      input.disabled = on;
    }

    function apply() {
      var code = input.value.trim();
      if (!code) return;
      busy(true);
      say('');

      currentCodes()
        .then(function (codes) {
          var names = codes.map(function (item) {
            return item.code;
          });
          var already = names.some(function (name) {
            return name.toUpperCase() === code.toUpperCase();
          });
          return already ? null : setCodes(names.concat(code));
        })
        .then(function () {
          window.location.reload();
        })
        .catch(function () {
          busy(false);
          say(box.getAttribute('data-error'));
        });
    }

    function remove(code) {
      busy(true);
      currentCodes()
        .then(function (codes) {
          return setCodes(
            codes
              .map(function (item) {
                return item.code;
              })
              .filter(function (name) {
                return name.toUpperCase() !== code.toUpperCase();
              })
          );
        })
        .then(function () {
          window.location.reload();
        })
        .catch(function () {
          busy(false);
          say(box.getAttribute('data-error'));
        });
    }

    applyButton.addEventListener('click', apply);

    /* Enter in the field must apply the code. Left alone it would submit the
       cart form, whose first submit button is Checkout. */
    input.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      apply();
    });

    box.addEventListener('click', function (event) {
      var button = event.target.closest('[data-cart-discount-remove]');
      if (button) remove(button.getAttribute('data-cart-discount-remove'));
    });

    /* Liquid only lists codes that change the cart. Two kinds never do, so
       they come from /cart.js with a note: a code the cart cannot use yet (a
       minimum not met), and a code that applies but only at checkout, which
       is a shipping code. The second also means the flat shipping row is not
       what checkout will charge, so the summary stops adding it and shows the
       total before shipping instead. */
    function checkoutShipping() {
      var shipping = document.querySelector('[data-cart-shipping]');
      if (!shipping) return;
      shipping.textContent = box.getAttribute('data-shipping-at-checkout');
      document.querySelectorAll('[data-cart-total]').forEach(function (node) {
        node.textContent = box.getAttribute('data-total-before-shipping');
      });
      document.querySelectorAll('[data-cart-total-label]').forEach(function (node) {
        node.textContent = box.getAttribute('data-total-before-shipping-label');
      });
      document.querySelectorAll('[data-cart-shipping-message]').forEach(function (node) {
        node.hidden = true;
      });
    }

    currentCodes()
      .then(function (codes) {
        codes.forEach(function (item) {
          var listed = Array.prototype.some.call(list.querySelectorAll('[data-code]'), function (node) {
            return node.getAttribute('data-code').toUpperCase() === item.code.toUpperCase();
          });
          if (listed) return;

          var note = item.applicable ? 'data-at-checkout' : 'data-pending';
          if (item.applicable) checkoutShipping();

          var entry = document.createElement('li');
          entry.className = 'cart__discount-code' + (item.applicable ? '' : ' cart__discount-code--pending');
          entry.setAttribute('data-code', item.code);

          var text = document.createElement('span');
          text.textContent = box.getAttribute(note).replace('__CODE__', item.code);
          entry.appendChild(text);

          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'cart__discount-remove';
          button.setAttribute('data-cart-discount-remove', item.code);
          button.setAttribute('aria-label', box.getAttribute('data-remove-label').replace('__CODE__', item.code));
          button.textContent = list.getAttribute('data-remove-text') || 'Remove';
          entry.appendChild(button);

          list.appendChild(entry);
        });
      })
      .catch(function () {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-support"] && !Shopify.designMode) return;
  try {
    
  class ContactSupport extends HTMLElement {
    connectedCallback() {
      this.chooser = this.querySelector('[data-reason-chooser]');
      this.list = this.querySelector('[data-reason-list]');
      this.build();

      this.addEventListener('click', (event) => {
        const tile = event.target.closest('[data-reason-target]');
        // A tile carrying a URL is a link; let the browser navigate.
        if (tile && !tile.hasAttribute('href')) this.show(tile.dataset.reasonTarget, true);
      });
    }

    get panels() {
      return Array.from(this.querySelectorAll('[data-reason-panel]'));
    }

    get tiles() {
      return Array.from(this.querySelectorAll('[data-reason-target]'));
    }

    build() {
      const panels = this.panels;
      if (!this.chooser || !this.list || panels.length < 2) return;

      this.list.textContent = '';
      panels.forEach((panel) => {
        const url = panel.dataset.reasonUrl;
        const tile = document.createElement(url ? 'a' : 'button');
        tile.className = 'ss-card contact-support__reason';
        tile.dataset.reasonTarget = panel.dataset.reasonPanel;

        if (url) {
          tile.href = url;
        } else {
          tile.type = 'button';
          tile.setAttribute('aria-pressed', 'false');
          tile.setAttribute('aria-controls', panel.id);
        }

        const check = this.querySelector('[data-reason-check]');
        if (!url && check) tile.appendChild(check.content.cloneNode(true));

        const label = document.createElement('span');
        label.className = 'contact-support__reason-label';
        label.textContent = panel.dataset.reasonLabel || '';
        tile.appendChild(label);

        const helpText = panel.dataset.reasonHelp;
        if (helpText) {
          const help = document.createElement('span');
          help.className = 'contact-support__reason-help';
          help.textContent = helpText;
          tile.appendChild(help);
        }

        this.list.appendChild(tile);
      });

      this.classList.add('contact-support--enhanced');
      this.chooser.hidden = false;
      // Open the first reason on load (owner, 2026-09-03) unless the section
      // says otherwise; the chooser stays visible so switching is one click.
      if (this.dataset.openFirst === 'true' && panels[0]) {
        this.show(panels[0].dataset.reasonPanel, false);
      } else {
        this.reset(false);
      }
    }

    mark(id) {
      this.tiles.forEach((tile) => {
        if (!tile.hasAttribute('aria-pressed')) return;
        tile.setAttribute('aria-pressed', tile.dataset.reasonTarget === id ? 'true' : 'false');
      });
    }

    show(id, moveFocus) {
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.reasonPanel !== id;
      });
      this.mark(id);

      if (!moveFocus) return;
      const active = this.panels.find((panel) => !panel.hidden);
      if (!active) return;
      const heading = active.querySelector('[id^="panel-heading-"]');
      if (heading) heading.focus();
    }

    reset(moveFocus) {
      this.panels.forEach((panel) => {
        panel.hidden = true;
      });
      this.mark(null);

      if (!moveFocus) return;
      const first = this.querySelector('[data-reason-target]');
      if (first) first.focus();
    }
  }

  if (!customElements.get('contact-support')) {
    customElements.define('contact-support', ContactSupport);
  }

  document.addEventListener('shopify:block:select', (event) => {
    const host = event.target.closest('contact-support');
    if (!host) return;
    const panel = event.target.closest('[data-reason-panel]');
    if (panel) host.show(panel.dataset.reasonPanel, false);
  });

  document.addEventListener('shopify:block:deselect', (event) => {
    const host = event.target.closest('contact-support');
    if (host) host.reset(false);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["design-guide"] && !Shopify.designMode) return;
  try {
    
  class GuideNav {
    constructor(root) {
      this.links = new Map();

      root.querySelectorAll('.guide__nav-link').forEach((link) => {
        const id = decodeURIComponent(link.hash.slice(1));
        const section = id ? root.querySelector(`#${CSS.escape(id)}`) : null;
        if (section) this.links.set(section, link);
      });

      if (this.links.size === 0) return;
      if (!('IntersectionObserver' in window)) return;

      this.visible = new Set();
      this.observer = new IntersectionObserver((entries) => this.update(entries), {
        rootMargin: '-10% 0px -70% 0px',
        threshold: 0,
      });

      this.links.forEach((_link, section) => this.observer.observe(section));
    }

    update(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.visible.add(entry.target);
        } else {
          this.visible.delete(entry.target);
        }
      });

      const sections = Array.from(this.links.keys());
      const current = sections.find((section) => this.visible.has(section));

      this.links.forEach((link, section) => {
        if (section === current) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }
  }

  document.querySelectorAll('.guide').forEach((root) => {
    if (root.dataset.guideNavReady) return;
    root.dataset.guideNavReady = 'true';
    new GuideNav(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class MenuDrawer extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('button[aria-controls]');
      this.panel = this.querySelector('dialog');
      this.label = this.querySelector('[data-menu-label]');

      if (!this.toggle || !this.panel) return;

      this.openIcon = this.querySelector('[data-menu-icon="open"]');
      this.closeIcon = this.querySelector('[data-menu-icon="close"]');
      this.labels = {
        open: this.label ? this.label.textContent : '',
        close: this.dataset.closeLabel || '',
      };

      this.onToggle = this.onToggle.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onResize = this.onResize.bind(this);

      this.toggle.addEventListener('click', this.onToggle);
      this.addEventListener('keydown', this.onKeydown);
      window.addEventListener('resize', this.onResize);

      this.setTop();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
    }

    get isOpen() {
      return this.panel.hasAttribute('open');
    }

    setTop() {
      const header = this.closest('header');
      if (!header) return;
      this.panel.style.setProperty('--menu-drawer-top', `${header.getBoundingClientRect().bottom}px`);
    }

    onResize() {
      if (this.isOpen) this.setTop();
    }

    onToggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }

    open() {
      this.setTop();
      this.panel.show();
      this.toggle.setAttribute('aria-expanded', 'true');
      if (this.openIcon) this.openIcon.hidden = true;
      if (this.closeIcon) this.closeIcon.hidden = false;
      if (this.label && this.labels.close) this.label.textContent = this.labels.close;

      const first = this.panel.querySelector('a, button');
      if (first) first.focus();
    }

    close(returnFocus = true) {
      this.panel.close();
      this.toggle.setAttribute('aria-expanded', 'false');
      if (this.openIcon) this.openIcon.hidden = false;
      if (this.closeIcon) this.closeIcon.hidden = true;
      if (this.label && this.labels.open) this.label.textContent = this.labels.open;
      if (returnFocus) this.toggle.focus();
    }

    onKeydown(event) {
      if (event.key !== 'Escape' || !this.isOpen) return;
      event.preventDefault();
      this.close();
    }
  }

  if (!customElements.get('menu-drawer')) {
    customElements.define('menu-drawer', MenuDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-center"] && !Shopify.designMode) return;
  try {
    
  class HelpCenterFilter {
    constructor(root) {
      this.root = root;
      this.pills = Array.from(root.querySelectorAll('.help-center__pill'));
      this.groups = Array.from(root.querySelectorAll('.help-center__group'));
      this.active = null;

      this.pills.forEach((pill) => {
        pill.addEventListener('click', (event) => {
          event.preventDefault();
          const target = pill.dataset.helpTarget;
          this.apply(target === this.active ? null : target);
        });
      });
    }

    apply(target) {
      this.active = target;
      this.root.classList.toggle('help-center--filtered', Boolean(target));

      this.groups.forEach((group) => {
        group.hidden = Boolean(target) && group.id !== target;
      });

      this.pills.forEach((pill) => {
        if (pill.dataset.helpTarget === target) {
          pill.setAttribute('aria-current', 'true');
        } else {
          pill.removeAttribute('aria-current');
        }
      });
    }
  }

  document.querySelectorAll('.help-center').forEach((root) => {
    if (root.dataset.helpCenterReady) return;
    root.dataset.helpCenterReady = 'true';
    new HelpCenterFilter(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductPage extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('[data-variant-select]');
      this.addButton = this.querySelector('[data-add-button]');
      this.priceTarget = this.querySelector('[data-price]');
      this.optionInputs = Array.from(this.querySelectorAll('[data-option-input]'));

      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-option-input]')) this.onOptionChange();
      });

      this.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-media-target]');
        if (thumb) this.showMedia(thumb.dataset.mediaTarget);

        const step = event.target.closest('[data-gallery-step]');
        if (step) this.stepMedia(Number(step.dataset.galleryStep) || 1);
      });
    }

    get selectedOptions() {
      const byPosition = new Map();
      this.optionInputs.forEach((input) => {
        if (!input.checked) return;
        const fieldset = input.closest('[data-option-position]');
        byPosition.set(Number(fieldset.dataset.optionPosition), input.value);
      });
      return Array.from(byPosition.keys())
        .sort((a, b) => a - b)
        .map((key) => byPosition.get(key));
    }

    onOptionChange() {
      if (!this.select) return;
      const wanted = this.selectedOptions.join('~~');
      const match = Array.from(this.select.options).find(
        (option) => option.dataset.variantOptions === wanted
      );

      this.updateOptionEchoes();
      if (!match) {
        this.setUnavailable();
        return;
      }

      this.select.value = match.value;
      this.select.dispatchEvent(new Event('change', { bubbles: true }));
      this.updatePrice(match);
      this.updateButton(match.dataset.variantAvailable === 'true');
      if (match.dataset.variantMedia) this.showMedia(match.dataset.variantMedia);
      this.updateUrl(match.value);
    }

    updateOptionEchoes() {
      this.querySelectorAll('[data-option-position]').forEach((fieldset) => {
        const checked = fieldset.querySelector('[data-option-input]:checked');
        const echo = fieldset.querySelector('[data-option-value]');
        if (checked && echo) echo.textContent = checked.value;
      });
    }

    updatePrice(option) {
      if (!this.priceTarget) return;
      const current = this.priceTarget.querySelector('.price__current');
      const compare = this.priceTarget.querySelector('.price__compare');
      if (current) current.textContent = option.dataset.variantPrice;
      if (compare) compare.textContent = option.dataset.variantCompare || '';
    }

    updateButton(available) {
      if (!this.addButton) return;
      this.addButton.disabled = !available;
      this.addButton.textContent = available
        ? this.addButton.dataset.labelAdd || this.addButton.textContent
        : this.addButton.dataset.labelSoldOut || this.addButton.textContent;
    }

    setUnavailable() {
      if (!this.addButton) return;
      this.addButton.disabled = true;
    }

    showMedia(mediaId) {
      this.querySelectorAll('[data-media-id]').forEach((item) => {
        item.hidden = item.dataset.mediaId !== String(mediaId);
      });
      this.querySelectorAll('[data-media-target]').forEach((thumb) => {
        if (thumb.dataset.mediaTarget === String(mediaId)) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    }

    stepMedia(offset) {
      const items = Array.from(this.querySelectorAll('[data-media-id]'));
      if (items.length < 2) return;
      let current = items.findIndex((item) => !item.hidden);
      if (current < 0) current = 0;
      const next = items[(current + offset + items.length) % items.length];
      this.showMedia(next.dataset.mediaId);
    }

    updateUrl(variantId) {
      if (!this.dataset.url) return;
      const url = new URL(this.dataset.url, window.location.origin);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    }
  }

  if (!customElements.get('product-page')) {
    customElements.define('product-page', ProductPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["proof"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.proof__cuts-toggle');
    if (!toggle) return;

    const proof = toggle.closest('[data-proof-state]');
    if (!proof) return;

    const sheet = proof.querySelector('.proof__sheet');
    if (!sheet) return;

    const hidden = sheet.classList.toggle('proof__sheet--no-cuts');
    toggle.setAttribute('aria-pressed', hidden ? 'false' : 'true');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simple-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* The price, the crossed-out price and the "Quantity · N sheets" echo
       follow whichever radio is checked. */
    function show(input) {
      var root = input.closest('.simple-product');
      var compare = input.getAttribute('data-compare') || '';
      root.querySelectorAll('[data-sp-price]').forEach(function (el) {
        el.textContent = input.getAttribute('data-price');
      });
      root.querySelectorAll('[data-sp-compare]').forEach(function (el) {
        el.hidden = compare === '';
        var value = el.querySelector('[data-sp-compare-value]');
        if (value) value.textContent = compare;
      });
      root.querySelectorAll('[data-sp-echo]').forEach(function (el) {
        var label = input.getAttribute('data-label');
        el.textContent = label ? ' · ' + label : '';
      });
    }

    function setCustom(step, on) {
      step.setAttribute('data-sp-custom', on ? 'true' : 'false');
      var toggle = step.querySelector('[data-sp-custom-toggle] input');
      if (toggle) toggle.checked = on;
      var field = step.querySelector('[data-sp-custom-field]');
      if (field) field.hidden = !on;
    }

    /* The nearest quantity the product has, among the hidden radios that
       hold every one: a typed 37 picks 35, a typed 3 the smallest. */
    function nearest(step, typed) {
      var best = null;
      step.querySelectorAll('[data-sp-any]:not(:disabled)').forEach(function (input) {
        var count = Number(input.getAttribute('data-count'));
        if (!best || Math.abs(count - typed) < Math.abs(Number(best.getAttribute('data-count')) - typed)) best = input;
      });
      return best;
    }

    function pickTyped(field, rewrite) {
      var step = field.closest('.simple-product__choices');
      if (field.value === '' || !Number.isFinite(Number(field.value))) return;
      var input = nearest(step, Number(field.value));
      if (!input) return;
      input.checked = true;
      show(input);
      if (rewrite) field.value = input.getAttribute('data-count');
      var slider = step.querySelector('[data-sp-custom-slider]');
      if (slider && slider !== field) slider.value = input.getAttribute('data-count');
    }

    function fromSlider(slider) {
      var step = slider.closest('.simple-product__choices');
      var field = step.querySelector('[data-sp-custom-input]');
      if (field) field.value = slider.value;
      pickTyped(slider, false);
    }

    function checkedCount(step) {
      var checked = step.querySelector('input[data-count]:checked');
      return checked ? checked.getAttribute('data-count') : '';
    }

    document.querySelectorAll('[data-sp-custom-toggle]').forEach(function (toggle) {
      toggle.hidden = false;
    });

    document.addEventListener('change', function (event) {
      var target = event.target;

      if (target.closest('[data-sp-custom-toggle]')) {
        var step = target.closest('.simple-product__choices');
        var field = step.querySelector('[data-sp-custom-input]');
        var count = checkedCount(step);
        setCustom(step, true);
        if (field) {
          if (count) field.value = count;
          pickTyped(field, true);
          field.focus();
          field.select();
        }
        return;
      }

      if (target.matches('[data-sp-custom-input]')) {
        pickTyped(target, true);
        return;
      }

      if (target.matches('[data-sp-custom-slider]')) {
        fromSlider(target);
        return;
      }

      var choice = target.closest('[data-sp-choice]');
      if (!choice) return;
      var input = choice.querySelector('input');
      var choices = choice.closest('.simple-product__choices');
      if (choices && choices.hasAttribute('data-sp-custom')) setCustom(choices, false);
      show(input);
    });

    document.addEventListener('input', function (event) {
      if (event.target.matches('[data-sp-custom-input]')) pickTyped(event.target, false);
      if (event.target.matches('[data-sp-custom-slider]')) fromSlider(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upload-artwork"] && !Shopify.designMode) return;
  try {
    
  class UploadArtwork extends HTMLElement {
    connectedCallback() {
      /* Until OkayProof's limits arrive; loadLimits() replaces both. */
      this.maxFiles = 10;
      this.maxBytes = parseInt(this.dataset.maxBytes, 10) || 0;
      this.uploadProxy = (this.dataset.uploadProxyPath || '/apps/upload').replace(/\/$/, '');
      /* Not this.prefix: Element.prototype.prefix is read-only and assigning
         to it throws, which silently kills connectedCallback. */
      this.namePrefix = this.dataset.propertyPrefix || 'Artwork';
      this.accept = this.dataset.accept || '';
      this.currency = this.dataset.currency || '$';

      this.formEl = this.querySelector('[data-ss-form]');
      this.filesEl = this.querySelector('[data-ss-files]');
      this.addRow = this.querySelector('[data-ss-add-row]');
      this.addBtn = this.querySelector('[data-ss-add]');
      this.submitBtn = this.querySelector('[data-ss-submit]');
      this.stickyBtn = this.querySelector('[data-ss-sticky-submit]');
      this.errorEl = this.querySelector('[data-ss-error]');
      this.missingEl = this.querySelector('[data-ss-missing]');
      this.summaryEl = this.querySelector('[data-ss-summary]');
      this.mainEl = this.querySelector('[data-ss-main]');
      this.stickyEl = this.querySelector('[data-ss-sticky]');
      this.leadEl = this.querySelector('[data-ss-lead]');
      this.notesEl = this.querySelector('[data-ss-notes]');
      this.laterOfferEl = this.querySelector('[data-ss-later-offer]');
      this.laterCardEl = this.querySelector('[data-ss-later-card]');
      this.laterValueEl = this.querySelector('[data-ss-later-value]');
      this.laterBtn = this.querySelector('[data-ss-later-submit]');
      this.later = false;

      this.strings = {
        drop: this.getAttribute('data-t-drop') || 'Drop your file here',
        choose: this.getAttribute('data-t-choose') || 'Choose files',
        photo: this.getAttribute('data-t-photo') || 'Take a photo',
        or: this.getAttribute('data-t-or') || 'or',
        paste: this.getAttribute('data-t-paste') || 'Paste a copied image',
        pasteEmpty: this.getAttribute('data-t-paste-empty') || 'There is no image on your clipboard.',
        pasteBlocked: this.getAttribute('data-t-paste-blocked') || 'Your browser did not allow pasting.',
        remove: this.getAttribute('data-t-remove') || 'Remove',
        replace: this.getAttribute('data-t-replace') || 'Replace file',
        needOne: this.getAttribute('data-t-need-one') || 'Add at least one file to continue.',
        badType: this.getAttribute('data-t-bad-type') || 'That file type is not supported.',
        badWebp:
          this.getAttribute('data-t-bad-webp') ||
          'This looks like a WebP image. Please upload a JPG, PNG, PDF, or another accepted format instead.',
        tooBig: this.getAttribute('data-t-too-big') || 'That file is too large.',
        checkType: this.getAttribute('data-t-check-type') || 'A file type we can print',
        checkSize: this.getAttribute('data-t-check-size') || 'Within the upload limit',
        checkVector: this.getAttribute('data-t-check-vector') || 'Vector: prints at any size',
        checkSharp: this.getAttribute('data-t-check-sharp') || 'Sharp at %SIZE%',
        checkLow: this.getAttribute('data-t-check-low') || 'Below 300 dpi at this size.',
        vectorUnconfirmed:
          this.getAttribute('data-t-vector-unconfirmed') || 'Vector file: confirm the checklist to continue',
        vectorReview: this.getAttribute('data-t-vector-review') || 'Review checklist',
        vectorConfirmed: this.getAttribute('data-t-vector-confirmed') || 'Vector checklist confirmed',
        sheets: this.getAttribute('data-t-sheets') || '%COUNT% sheets',
        each: this.getAttribute('data-t-each') || '%PRICE%/ea',
        leadEmpty: this.getAttribute('data-t-lead-empty') || '',
        unreachable:
          this.getAttribute('data-t-unreachable') ||
          'We could not reach pricing. Please try again.',
        cartFailed:
          this.getAttribute('data-t-cart-failed') ||
          'That could not be added to your cart. Please try again.',
        adding: this.getAttribute('data-t-adding') || 'Adding to cart…',
        editing: this.getAttribute('data-t-editing') || '',
        update: this.getAttribute('data-t-update') || 'Update cart',
        kept: this.getAttribute('data-t-kept') || 'Already attached',
        multiHint: this.getAttribute('data-t-multi-hint') || '',
        tooMany: this.getAttribute('data-t-too-many') || 'Up to %MAX% images per sheet.',
        layoutAlone:
          this.getAttribute('data-t-layout-alone') ||
          'A PDF, AI or EPS file is a whole sheet layout, so upload it on its own.',
        uploading: this.getAttribute('data-t-uploading') || 'Uploading %PERCENT%',
        uploaded: this.getAttribute('data-t-uploaded') || 'Uploaded',
        uploadFailed: this.getAttribute('data-t-upload-failed') || 'The upload did not finish.',
        tryAgain: this.getAttribute('data-t-try-again') || 'Try again',
        stillUploading: this.getAttribute('data-t-still-uploading') || 'Your files are still uploading.'
      };

      this.loadLimits();

      this.extensions = this.accept
        .split(',')
        .map(function (part) { return part.trim().toLowerCase(); })
        .filter(function (part) { return part.charAt(0) === '.'; });

      this.vectorTypes = ['.pdf', '.ai', '.eps', '.svg'];
      /* What sniffFormat calls a vector file. AI saves as PDF or PostScript. */
      this.vectorFormats = ['pdf', 'postscript', 'svg'];
      /* The checklist is the vector list without SVG, which rarely has cut
         lines and so cannot answer the first question honestly. */
      this.checklistTypes = ['.pdf', '.ai', '.eps'];
      this.checklistFormats = ['pdf', 'postscript'];
      /* A PDF, AI or EPS file is one whole sheet layout, so it goes alone.
         An SVG is usually one design, so it can sit beside images. */
      this.layoutTypes = this.checklistTypes;
      /* What browsers leave blank or guess wrong, from the name instead
         (OkayProof's reference client does the same). */
      this.mimeByExtension = {
        '.ai': 'application/postscript',
        '.eps': 'application/postscript',
        '.psd': 'image/vnd.adobe.photoshop',
        '.tif': 'image/tiff',
        '.tiff': 'image/tiff',
        '.heic': 'image/heic',
        '.heif': 'image/heif',
        '.pdf': 'application/pdf',
        '.svg': 'image/svg+xml',
        '.png': 'image/png',
        '.jpg': 'image/jpeg',
        '.jpeg': 'image/jpeg'
      };
      this.checklistEl = this.querySelector('[data-ss-checklist]');
      this.bindChecklist();
      this.rasterTypes = ['.jpg', '.jpeg', '.png', '.tif', '.tiff', '.heic', '.heif'];
      this.previewTypes = ['.jpg', '.jpeg', '.png', '.svg', '.gif', '.webp'];
      this.previews = [];

      const params = new URLSearchParams(window.location.search);
      this.variantId = params.get('variant') || '';
      this.handle = params.get('product') || '';
      /* Set by the cart's Edit link: the key of the line this sheet replaces. */
      this.editKey = params.get('edit') || '';
      this.proxy = (this.dataset.proxyPath || '').replace(/\/$/, '');

      /*
       * A sheet arrives as a configuration, not a variant. The numbers travel
       * in the URL and are not trusted: the service re-prices them here for
       * confirmation and again at submit, and ignores any price. A hand-edited
       * link therefore buys a different sheet, never a cheaper one.
       */
      this.configuration = params.has('width') && params.has('height') && params.has('quantity') && params.has('finish')
        ? {
            widthIn: Number(params.get('width')),
            heightIn: Number(params.get('height')),
            quantity: Number(params.get('quantity')),
            finish: params.get('finish')
          }
        : this.stashedConfiguration();

      if (!this.variantId && !this.configuration) {
        this.missingEl.hidden = false;
        return;
      }

      if (this.configuration) {
        this.confirmConfiguration();
        return;
      }

      /* A plain ?variant= link has no configuration to confirm, so it goes
         straight to the form. */
      this.querySelector('[data-ss-variant]').value = this.variantId;
      this.applyProperties(params.get('props'));
      this.showForm();
      this.addSlot();
      this.bind();

      if (this.handle) this.loadSummary();
      this.wireChangeLinks();
    }

    disconnectedCallback() {
      this.previews.forEach(function (url) { URL.revokeObjectURL(url); });
      this.previews = [];
      if (this.onHide) document.removeEventListener('visibilitychange', this.onHide);
      if (this.onPasteEvent) document.removeEventListener('paste', this.onPasteEvent);
    }

    /*
     * The product page keeps the configuration in session storage as well as
     * in the Continue link. Shopify's Sign in with Shop handshake can rewrite
     * the first URL of a visit and drop its parameters - seen leaving this
     * page with only `product=` - so when the URL says nothing, the copy from
     * the same session is used. It is not trusted any more than the URL is:
     * the service re-prices it exactly the same way.
     */
    stashedConfiguration() {
      let raw;
      try {
        raw = window.sessionStorage.getItem('ss:configuration');
      } catch (error) {
        return null;
      }
      if (!raw) return null;

      let stashed;
      try {
        stashed = JSON.parse(raw);
      } catch (error) {
        return null;
      }

      const TWO_HOURS = 2 * 60 * 60 * 1000;
      if (!stashed || typeof stashed !== 'object') return null;
      if (!(Date.now() - Number(stashed.at || 0) < TWO_HOURS)) return null;
      if (!stashed.widthIn || !stashed.heightIn || !stashed.quantity || !stashed.finish) return null;
      if (this.handle && stashed.product && stashed.product !== this.handle) return null;

      if (!this.handle && stashed.product) this.handle = stashed.product;

      return {
        widthIn: Number(stashed.widthIn),
        heightIn: Number(stashed.heightIn),
        quantity: Number(stashed.quantity),
        finish: String(stashed.finish)
      };
    }

    /*
     * Confirm the configuration against the service before showing anything, so
     * an out-of-range or malformed link fails here with a readable reason rather
     * than silently at the final button.
     */
    async confirmConfiguration() {
      const result = await this.quote('/sheet-quote', this.configuration);

      if (!result.ok) {
        this.missingEl.hidden = false;
        const reason = result.body && result.body.error;
        if (reason) {
          this.missingEl.querySelector('.ss-upload__missing-text').textContent = reason;
        }
        return;
      }

      /* The service re-snaps, so confirm what it returned, not what was typed. */
      this.configuration = {
        widthIn: result.body.widthIn,
        heightIn: result.body.heightIn,
        quantity: result.body.quantity,
        finish: result.body.finish
      };
      this.totalCents = Math.round(result.body.totalUsd * 100);

      this.fillConfiguration();
      this.wireChangeLinks();
      this.summaryEl.hidden = false;
      this.showForm();

      if (this.editKey) await this.loadEditLine();
      if (!this.filesEl.children.length) this.addSlot();
      this.bind();

      /* Ask for the variant now, while the customer is choosing a file. */
      this.prepareVariant();
    }

    /* One set of confirmed numbers, written into the aside and the sticky bar
       at once, so the two can never disagree. */
    fillConfiguration() {
      const size = this.sizeLabel();
      const finish = this.configuration.finish;
      const sheets = this.strings.sheets.replace('%COUNT%', String(this.configuration.quantity));
      const each = this.strings.each.replace(
        '%PRICE%',
        this.money(Math.round(this.totalCents / this.configuration.quantity))
      );
      const total = this.money(this.totalCents);

      this.setText('[data-ss-summary-size]', size);
      this.setText('[data-ss-summary-finish]', finish);
      this.setText('[data-ss-summary-quantity]', sheets);
      this.setText('[data-ss-summary-price]', total);
      this.setText('[data-ss-each]', each);
      this.setText('[data-ss-layout-hint]', this.dataset.tLayoutHint.replace('%SIZE%', size));

      this.setText('[data-ss-sticky-total]', total);
      this.setText('[data-ss-sticky-echo]', size + ' · ' + finish + ' · ' + sheets);
    }

    setText(selector, value) {
      const nodes = this.querySelectorAll(selector);
      Array.prototype.forEach.call(nodes, function (node) {
        node.textContent = value;
      });
    }

    /*
     * Change goes back to the product page carrying the configuration, and the
     * order panel opens on it. While editing a cart line the key rides along,
     * so coming back here still replaces that line.
     */
    wireChangeLinks() {
      const href = this.changeHref();
      if (!href) return;
      const links = this.querySelectorAll('[data-ss-change]');
      Array.prototype.forEach.call(links, function (link) {
        link.setAttribute('href', href);
      });
    }

    changeHref() {
      if (!this.handle) return this.dataset.backLink || '';

      /* A plain variant (a fixed-price product such as the Gift Tag Sheet) goes
         back to its product page on the same variant. */
      if (!this.configuration) {
        const variant = this.variantId ? '?variant=' + encodeURIComponent(this.variantId) : '';
        return this.root() + 'products/' + encodeURIComponent(this.handle) + variant;
      }

      const query = [
        'width=' + encodeURIComponent(this.configuration.widthIn),
        'height=' + encodeURIComponent(this.configuration.heightIn),
        'quantity=' + encodeURIComponent(this.configuration.quantity),
        'finish=' + encodeURIComponent(this.configuration.finish)
      ];
      if (this.editKey) query.push('edit=' + encodeURIComponent(this.editKey));

      return this.root() + 'products/' + encodeURIComponent(this.handle) + '?' + query.join('&');
    }

    showForm() {
      this.mainEl.hidden = false;
      this.stickyEl.hidden = false;
      this.refresh();
    }

    /*
     * The variant is asked for as soon as the configuration is confirmed, not
     * when the button is pressed. A freshly minted variant is not addable for
     * a while - Shopify answers 422 until it reaches the storefront - and
     * measured from the outside that wait, plus the retries it forces,
     * pushed the button press to tens of seconds. Resolving it here hides
     * that propagation behind the time the customer spends picking a file.
     *
     * The cost is a variant for every confirmed configuration that never
     * submits. The service reaps one no cart ever held in minutes, so that
     * pool stays small. A stock configuration costs nothing: it resolves to
     * its existing variant.
     */
    prepareVariant() {
      this.resolvedVariant = null;
      const attempt = (this.resolveAttempt = (this.resolveAttempt || 0) + 1);

      this.resolving = this.quote('/sheet-cart', this.configuration).then((result) => {
        if (attempt !== this.resolveAttempt) return null;
        if (!result.ok || !result.body.variantId) return null;
        this.resolvedVariant = { body: result.body, at: Date.now() };
        return this.resolvedVariant;
      });

      return this.resolving;
    }

    /*
     * The service reaps a never-carted variant after a while, so one
     * prepared long ago may be gone by the time the button is pressed. Well
     * inside that window it is reused; past it, a fresh one is asked for.
     */
    async resolvedForSubmit() {
      const FRESH_MS = 15 * 60 * 1000;
      const ready = this.resolving ? await this.resolving : null;
      if (ready && Date.now() - ready.at < FRESH_MS) return ready.body;
      const fresh = await this.prepareVariant();
      return fresh ? fresh.body : null;
    }

    /*
     * The customer has confirmed the configuration and attached their artwork.
     * The service re-prices the configuration and resolves or mints at its own
     * figure, so nothing on this page can influence the total.
     */
    async submitConfiguration() {
      if (this.busy) return;
      this.busy = true;
      this.setBusyLabel(true);
      this.clearError();

      const resolved = await this.resolvedForSubmit();

      if (!resolved) {
        this.setBusyLabel(false);
        this.busy = false;
        this.showError(this.strings.cartFailed);
        return;
      }

      this.querySelector('[data-ss-variant]').value = resolved.variantId;
      this.applyProperties(JSON.stringify(resolved.properties || {}));

      /* An empty note is no note: a disabled field is left out of FormData,
         so the order never carries a blank Notes property. */
      if (this.notesEl) this.notesEl.disabled = this.notesEl.value.trim() === '';

      const added = await this.addToCart(new FormData(this.formEl));

      if (this.notesEl) this.notesEl.disabled = false;

      if (!added) {
        this.setBusyLabel(false);
        this.busy = false;
        this.showError(this.strings.cartFailed);
        return;
      }

      if (this.editKey) await this.replaceEditedLine(added);

      window.location.href = this.root() + 'cart';
    }

    /*
     * Editing a cart line: the cart's Edit link sent the line's key along with
     * its configuration. Its artwork is shown as already attached and posted
     * again as stored (file name and upload id, or the Shopify link on a line
     * from before OkayProof), so nothing is uploaded twice, and its
     * layout and notes are filled back in. A key that matches no line is
     * dropped, and the page becomes an ordinary add.
     */
    async loadEditLine() {
      let item = null;
      try {
        const response = await fetch(this.root() + 'cart.js', { headers: { Accept: 'application/json' } });
        const cart = await response.json();
        item = (cart.items || []).find((line) => line.key === this.editKey) || null;
      } catch (error) {
        item = null;
      }

      if (!item) {
        this.editKey = '';
        this.wireChangeLinks();
        return;
      }

      const props = item.properties || {};
      const marker = this.namePrefix + ' ';
      Object.keys(props)
        .filter((key) => key.indexOf(marker) === 0 && /^\d+$/.test(key.slice(marker.length)) && props[key])
        .sort((a, b) => Number(a.slice(marker.length)) - Number(b.slice(marker.length)))
        .forEach((key) => {
          const id = props['_upload_id ' + key.slice(marker.length)];
          this.addKeptSlot(String(props[key]), id ? String(id) : '');
        });

      const layout = Array.prototype.find.call(
        this.formEl.querySelectorAll('input[name="properties[Layout]"]'),
        (input) => input.value === props.Layout
      );
      if (layout) layout.checked = true;
      if (props.Notes && this.notesEl) this.notesEl.value = props.Notes;
      /* A line sent to the cart as "email later" opens that way again. */
      if (this.laterValueEl && props[this.namePrefix] === this.laterValueEl.value) this.setLater(true, false);

      [this.submitBtn, this.stickyBtn, this.laterBtn].filter(Boolean).forEach((button) => {
        button.textContent = this.strings.update;
      });

      this.renumber();
      this.refresh();
    }

    /*
     * The edited line is replaced, not left beside the new one. When nothing
     * changed, Shopify merges the add into that same line and doubles it, so
     * it goes back to one sheet instead of being removed with the add inside.
     */
    async replaceEditedLine(added) {
      const line = added && Array.isArray(added.items) ? added.items[0] : added;
      const merged = !!line && line.key === this.editKey;
      try {
        await fetch(this.root() + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: this.editKey, quantity: merged ? 1 : 0 })
        });
      } catch (error) {
        /* The new line is in. A leftover old one shows in the cart with its
           own Remove, which beats blocking the customer here. */
      }
    }

    /* A disabled button with its label unchanged reads as a click that did
       not register. While the add is in flight the label says so. */
    setBusyLabel(busy) {
      const buttons = [this.submitBtn, this.stickyBtn, this.laterBtn].filter(Boolean);

      if (busy) {
        this.idleLabel = this.submitBtn.textContent;
        buttons.forEach((button) => {
          button.textContent = this.strings.adding;
          button.setAttribute('aria-busy', 'true');
          button.disabled = true;
        });
        return;
      }

      buttons.forEach((button) => {
        if (this.idleLabel) button.textContent = this.idleLabel;
        button.removeAttribute('aria-busy');
        button.disabled = false;
      });
    }

    root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    /*
     * A just-created variant is briefly not addable (Shopify answers 422 until
     * it reaches the storefront), so the add backs off and retries. A 429 is the
     * cart throttle and is never retried: another call while throttled only
     * refills the bucket and extends the lockout.
     */
    async addToCart(data) {
      for (let attempt = 0; attempt < 5; attempt++) {
        let response;
        try {
          response = await fetch(this.root() + 'cart/add.js', { method: 'POST', body: data });
        } catch (error) {
          return false;
        }

        if (response.ok) {
          try {
            return await response.json();
          } catch (error) {
            return {};
          }
        }
        if (response.status !== 422) return false;

        await new Promise((resolve) => {
          setTimeout(resolve, Math.min(1500 * Math.pow(1.6, attempt), 6000));
        });
      }

      return false;
    }

    async quote(path, payload) {
      try {
        const response = await fetch(this.proxy + path, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        return { ok: response.ok, body: await response.json() };
      } catch (error) {
        return { ok: false, body: { error: this.strings.unreachable } };
      }
    }

    /*
     * Line item properties describing the sheet, from the service's reply or
     * from a `props` query parameter on a legacy link, are re-emitted here so
     * the one cart POST carries both the artwork and what the sheet actually
     * is.
     *
     * Only flat string values are accepted, and the keys are written as-is into
     * properties[...]: anything else is ignored rather than guessed at.
     */
    applyProperties(raw) {
      if (!raw) return;

      let parsed;
      try {
        parsed = JSON.parse(raw);
      } catch (error) {
        return;
      }

      if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return;

      Object.keys(parsed).forEach((key) => {
        const value = parsed[key];
        if (value === null || typeof value === 'object') return;

        const field = document.createElement('input');
        field.type = 'hidden';
        field.name = 'properties[' + key + ']';
        field.value = String(value);
        this.formEl.appendChild(field);
      });
    }

    bind() {
      this.addBtn.addEventListener('click', () => {
        this.addSlot();
        const last = this.filesEl.lastElementChild;
        if (last) last.querySelector('input[type="file"]').click();
      });

      if (this.laterOfferEl) {
        this.querySelector('[data-ss-later]').addEventListener('click', () => {
          this.setLater(true, true);
          this.track('Upload: send later chosen');
        });
        this.querySelector('[data-ss-later-undo]').addEventListener('click', () => this.setLater(false, true));
      }

      this.onPasteEvent = (event) => this.onPaste(event);
      document.addEventListener('paste', this.onPasteEvent);

      this.formEl.addEventListener('submit', (event) => {
        if (!this.later && this.countFiles() < 1) {
          event.preventDefault();
          this.showError(this.strings.needOne);
          return;
        }

        /* The buttons are disabled meanwhile; this covers any other way in. */
        if (!this.later && !this.uploadsDone()) {
          event.preventDefault();
          this.showError(this.strings.stillUploading);
          return;
        }

        /* Fires for both paths below, so the funnel closes whether the sheet
           needed a variant minted or posted straight to the cart. */
        this.track('Upload: submitted', { files: this.later ? 'later' : String(this.countFiles()) });

        /* A configured sheet has no variant yet. Resolve it now, with the
           artwork in hand, then post the cart line ourselves so the add can
           be retried. */
        if (this.configuration) {
          event.preventDefault();
          this.submitConfiguration();
        }
      });
    }

    /*
     * Sending the artwork later swaps the file area for the card and posts
     * the fixed Artwork value in place of a file. The slots' fields are
     * disabled rather than removed, so nothing of a file is posted with it
     * and Upload a file instead returns the dropzone as it was.
     */
    setLater(on, moveFocus) {
      if (!this.laterCardEl) return;
      this.later = on;
      this.filesEl.hidden = on;
      this.laterCardEl.hidden = !on;
      this.laterValueEl.disabled = !on;
      this.filesEl.querySelectorAll('input').forEach((input) => {
        input.disabled = on;
      });
      this.clearError();
      this.refresh();
      if (!moveFocus) return;
      if (on) {
        this.laterCardEl.focus();
      } else {
        const choose = this.filesEl.querySelector('.ss-upload__drop button');
        if (choose) choose.focus();
      }
    }

    /* Slots are created as they are needed, so an order never carries an empty
       Artwork property for a file the customer never added. The file input
       is only the picker: it has no name, so no file is ever posted to
       Shopify. What posts is the pair of hidden fields an upload leaves. */
    addSlot() {
      const index = this.filesEl.children.length + 1;
      if (index > this.maxFiles) return null;

      const slot = document.createElement('div');
      slot.className = 'ss-upload__slot';

      const input = this.pickerInput(slot);
      input.disabled = this.later;

      slot.append(input);
      this.filesEl.append(slot);
      this.renderDropzone(slot, input);

      this.refresh();
      return slot;
    }

    pickerInput(slot) {
      const input = document.createElement('input');
      input.type = 'file';
      input.className = 'ss-upload__input';
      input.accept = this.accept;
      input.multiple = true;
      input.addEventListener('change', () => this.onChosen(slot, input));
      input.addEventListener('cancel', () => this.onCanceled(slot));
      return input;
    }

    /*
     * OkayProof's limits: the largest file and how many files one sheet can
     * carry. The page works on its defaults until they arrive, and keeps them
     * if they never do; OkayProof checks size and type again at the ticket.
     */
    loadLimits() {
      fetch(this.uploadProxy + '/limits', { headers: { Accept: 'application/json' } })
        .then((response) => (response.ok ? response.json() : null))
        .then((limits) => {
          if (!limits) return;
          const files = parseInt(limits.max_files_per_product, 10);
          if (files > 0) this.maxFiles = files;
          const bytes = parseInt(limits.max_bytes, 10);
          if (bytes > 0) this.maxBytes = this.maxBytes ? Math.min(this.maxBytes, bytes) : bytes;
          this.setText('.ss-upload__drop-formats', this.multiHint());
          this.refresh();
        })
        .catch(function () {});
    }

    multiHint() {
      return (this.strings.multiHint || '').replace('%MAX%', String(this.maxFiles));
    }

    maxMb() {
      return String(Math.floor(this.maxBytes / 1048576));
    }

    renderDropzone(slot, input) {
      this.clearSlot(slot);

      const zone = document.createElement('div');
      zone.className = 'ss-upload__drop';
      const icon = document.createElement('span');
      icon.className = 'ss-upload__upload-icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML = '<svg viewBox="0 0 24 24" fill="none"><path d="M7 17H5a4 4 0 0 1-1-7.87A7 7 0 0 1 17.8 8 4.5 4.5 0 0 1 19 17h-2M12 21V10m-4 4 4-4 4 4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      const title = document.createElement('p');
      title.className = 'ss-upload__drop-title';
      title.textContent = this.strings.drop;

      const formats = document.createElement('p');
      formats.className = 'ss-upload__drop-formats';
      formats.textContent = this.multiHint();

      const actions = document.createElement('div');
      actions.className = 'ss-upload__drop-actions';

      const choose = document.createElement('button');
      choose.type = 'button';
      choose.className = 'button button--primary button--small';
      choose.textContent = this.strings.choose;
      choose.addEventListener('click', () => {
        input.removeAttribute('capture');
        input.click();
      });

      /*
       * Take a photo is the same input with `capture` set for the one click,
       * not a second file field: two inputs sharing a property name would post
       * an empty part for whichever one was not used.
       */
      const photo = document.createElement('button');
      photo.type = 'button';
      photo.className = 'button button--secondary button--small ss-upload__photo';
      photo.textContent = this.strings.photo;
      photo.addEventListener('click', () => {
        input.setAttribute('capture', 'environment');
        input.click();
      });

      actions.append(choose, photo);
      zone.append(icon, title, formats, actions);

      /*
       * The paste field, for a cut-out copied on a phone: iOS "Copy subject"
       * and the Android equivalents put a transparent PNG on the clipboard,
       * and a phone has no keyboard to paste it with. Safari answers a
       * clipboard read with its own one-option Paste bubble beside the tap,
       * which no page can skip or restyle (WebKit allows a silent read only
       * for a keyboard paste or a same-origin copy). So the control is drawn
       * as a field, not a button: tapping a field and getting Paste above it
       * is the pattern iPhone users already know. The "or" row above it
       * leaves the bubble room so it does not land on Choose files. Offered
       * only where the browser can read the clipboard; a keyboard paste works
       * everywhere, see bind().
       */
      if (navigator.clipboard && typeof navigator.clipboard.read === 'function') {
        const or = document.createElement('p');
        or.className = 'ss-upload__or';
        or.textContent = this.strings.or;

        const field = document.createElement('button');
        field.type = 'button';
        field.className = 'ss-upload__paste';
        field.innerHTML = '<svg class="ss-upload__paste-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="5" y="4" width="14" height="17" rx="2" stroke="currentColor" stroke-width="1.7"/><path d="M9 4.5V3.8C9 3.36 9.36 3 9.8 3h4.4c.44 0 .8.36.8.8v.7c0 .44-.36.8-.8.8H9.8A.8.8 0 0 1 9 4.5Z" stroke="currentColor" stroke-width="1.7"/><path d="M9 11h6M9 15h4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';
        const label = document.createElement('span');
        label.className = 'ss-upload__paste-label';
        label.textContent = this.strings.paste;
        field.append(label);
        field.addEventListener('click', () => this.pasteFromClipboard(input, field));

        zone.append(or, field);
      }

      zone.append(this.querySelector('[data-ss-upload-details]').content.cloneNode(true));
      slot.append(zone);

      this.wireDragAndDrop(zone, input);
    }

    wireDragAndDrop(zone, input) {
      ['dragenter', 'dragover'].forEach((name) => {
        zone.addEventListener(name, (event) => {
          event.preventDefault();
          zone.classList.add('ss-upload__drop--dragging');
        });
      });

      ['dragleave', 'drop'].forEach((name) => {
        zone.addEventListener(name, () => {
          zone.classList.remove('ss-upload__drop--dragging');
        });
      });

      zone.addEventListener('drop', (event) => {
        event.preventDefault();
        const dropped = event.dataTransfer && event.dataTransfer.files;
        if (!dropped || !dropped.length) return;
        this.place(input.closest('.ss-upload__slot'), Array.prototype.slice.call(dropped));
      });
    }

    attach(input, file) {
      this.place(input.closest('.ss-upload__slot'), [file]);
    }

    /*
     * The paste field. read() has to be called straight from the tap: Safari
     * shows its own Paste bubble the customer confirms, and Chrome on Android
     * asks for permission the first time. While that is open the field holds
     * its focused look, as a text field does under the iOS Paste callout. The
     * first image type on the clipboard wins; anything else is ignored.
     */
    async pasteFromClipboard(input, field) {
      this.clearError();
      this.setPasteState(field, 'waiting');
      const asked = Date.now();
      let items;
      try {
        items = await navigator.clipboard.read();
      } catch (error) {
        /*
         * Tapping anywhere but Safari's bubble rejects the read (WebKit), and
         * that is the customer changing their mind, so the field just goes
         * back. A refusal that comes back faster than anyone could tap is
         * the browser saying no without asking, which is worth saying.
         */
        const refused = error && error.name === 'NotAllowedError' && Date.now() - asked < 400;
        this.setPasteState(field, refused ? 'error' : '', refused ? this.strings.pasteBlocked : '');
        return;
      }

      for (const item of items) {
        const type = item.types.find((name) => name.indexOf('image/') === 0);
        if (!type) continue;
        try {
          this.attach(input, this.pastedFile(await item.getType(type)));
        } catch (error) {
          this.setPasteState(field, 'error', this.strings.pasteBlocked);
        }
        return;
      }

      this.setPasteState(field, 'error', this.strings.pasteEmpty);
    }

    /* The field shows its own outcome in place of its label, so the answer
       sits where the customer is looking, and the next tap starts over. */
    setPasteState(field, state, message) {
      if (!field || !field.isConnected) return;
      field.dataset.state = state || '';
      field.querySelector('.ss-upload__paste-label').textContent = message || this.strings.paste;
    }

    /*
     * A pasted image has no file name, or a generic "image.png". It gets a
     * dated one with the extension its type implies, so the order shows
     * something readable and the type check has an extension to read.
     */
    pastedFile(blob) {
      const kinds = { 'image/png': '.png', 'image/jpeg': '.jpg', 'image/tiff': '.tif', 'image/heic': '.heic', 'image/gif': '.gif', 'image/webp': '.webp', 'image/svg+xml': '.svg' };
      const type = blob.type || 'image/png';
      const ext = kinds[type] || '.' + type.split('/').pop();
      const stamp = new Date().toISOString().slice(0, 19).replace('T', '-').replace(/:/g, '');
      return new File([blob], 'pasted-image-' + stamp + ext, { type: type });
    }

    /*
     * Cmd+V or Ctrl+V anywhere on the page, including a file copied in
     * Finder or Explorer. Text pastes are left alone, so the Notes field
     * still works. The file goes to an empty slot, or a new one while the
     * sheet has room, or else replaces the last file, the same as Replace file.
     */
    onPaste(event) {
      if (this.later || this.busy || this.mainEl.hidden) return;
      if (this.checklistEl && this.checklistEl.open) return;

      const data = event.clipboardData;
      if (!data) return;
      const files = Array.prototype.filter
        .call(data.items || [], (item) => item.kind === 'file')
        .map((item) => item.getAsFile())
        .filter(Boolean);
      if (!files.length) return;

      event.preventDefault();
      this.clearError();

      const slots = Array.prototype.slice.call(this.filesEl.children);
      const slot =
        slots.find((candidate) => !this.filled(candidate)) ||
        this.addSlot() ||
        slots[slots.length - 1];
      if (!slot) return;

      this.place(slot, files.map((file) => {
        const named = file.name && this.extensionOf(file.name) && file.name !== 'image.png';
        return named ? file : this.pastedFile(file);
      }));
    }

    /* The picker's files are read at once and the input is emptied, so
       choosing the same file again still fires change. */
    onChosen(slot, input) {
      const files = Array.prototype.slice.call(input.files || []);
      input.value = '';
      if (!files.length) {
        this.onCanceled(slot);
        return;
      }
      this.place(slot, files);
    }

    /* A canceled Replace keeps the file there. A canceled picker on an extra
       slot leaves nothing behind; the first slot stays the dropzone. */
    onCanceled(slot) {
      if (!this.filled(slot) && slot !== this.filesEl.firstElementChild) {
        slot.remove();
        this.renumber();
      }
      this.refresh();
    }

    filled(slot) {
      return !!(slot._ssFile || slot.querySelector('[data-ss-kept]'));
    }

    /* The name of whatever a slot holds: a new file, or one kept from the
       cart line, which is a bare name or, from before OkayProof, a link. */
    slotFileName(slot) {
      if (slot._ssFile) return slot._ssFile.name;
      const kept = slot.querySelector('[data-ss-kept]');
      return kept ? this.keptName(kept.value) : '';
    }

    keptName(value) {
      if (value.indexOf('/') === -1) return value;
      let name = value.split('?')[0].split('/').pop() || value;
      try {
        name = decodeURIComponent(name);
      } catch (error) {
        /* An undecodable name is shown as stored. */
      }
      return name;
    }

    /*
     * Files from the picker, a drop or a paste. The first goes in this slot
     * (replacing what was there) and the rest in new slots, up to the
     * sheet's limit. A PDF, AI or EPS file is a whole sheet layout, so it is
     * refused beside any other file rather than quietly dropped.
     */
    place(slot, files) {
      this.clearError();
      if (!slot || !files.length) return;

      const others = Array.prototype.filter.call(this.filesEl.children, (other) => {
        return other !== slot && this.filled(other);
      });
      const isLayout = (name) => this.layoutTypes.indexOf(this.extensionOf(name)) !== -1;
      const layout =
        files.some((file) => isLayout(file.name)) ||
        others.some((other) => isLayout(this.slotFileName(other)));

      if (layout && others.length + files.length > 1) {
        this.showError(this.strings.layoutAlone);
        this.onCanceled(slot);
        return;
      }

      const room = Math.max(1, this.maxFiles - others.length);
      files.slice(0, room).forEach((file, position) => {
        const target = position === 0 ? slot : this.addSlot();
        if (target) this.fillSlot(target, target.querySelector('input[type="file"]'), file);
      });
      if (files.length > room) this.showError(this.strings.tooMany.replace('%MAX%', String(this.maxFiles)));

      this.renumber();
      this.refresh();
    }

    /* A file already on the cart line being edited: its name and OkayProof
       upload id, or on a line from before OkayProof, the link Shopify stored.
       It counts as attached and is posted back as it was. Replace swaps in a
       new file, which clears it; Remove drops it. */
    addKeptSlot(value, uploadId) {
      if (this.filesEl.children.length >= this.maxFiles) return;

      const slot = document.createElement('div');
      slot.className = 'ss-upload__slot';

      const input = this.pickerInput(slot);

      const kept = document.createElement('input');
      kept.type = 'hidden';
      kept.value = value;
      kept.setAttribute('data-ss-kept', '');

      const keptId = document.createElement('input');
      keptId.type = 'hidden';
      keptId.value = uploadId || '';
      keptId.setAttribute('data-ss-kept-id', '');

      const fileName = this.keptName(value);
      const ext = this.extensionOf(fileName);
      const isLink = value.indexOf('/') !== -1;

      const card = document.createElement('div');
      card.className = 'ss-card ss-upload__file';

      const thumb = document.createElement('div');
      thumb.className = 'ss-upload__thumb';
      if (isLink && this.previewTypes.indexOf(ext) !== -1) {
        this.showPreview(thumb, card, value);
      } else {
        thumb.append(this.glyph());
      }

      const body = document.createElement('div');
      body.className = 'ss-upload__file-body';

      const name = document.createElement('p');
      name.className = 'ss-upload__file-name';
      name.textContent = fileName;

      const meta = document.createElement('p');
      meta.className = 'ss-upload__file-meta';
      meta.textContent = ext.replace('.', '').toUpperCase();

      const checks = document.createElement('ul');
      checks.className = 'ss-upload__checks';
      checks.setAttribute('role', 'list');
      checks.append(this.checkRow('pass', this.strings.kept));

      const actions = document.createElement('div');
      actions.className = 'ss-upload__file-actions';

      const replace = document.createElement('button');
      replace.type = 'button';
      replace.className = 'ss-upload__textlink ss-upload__textlink--accent';
      replace.textContent = this.strings.replace;
      replace.addEventListener('click', () => {
        input.removeAttribute('capture');
        input.click();
      });

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'ss-upload__textlink';
      remove.textContent = this.strings.remove;
      remove.addEventListener('click', () => {
        slot.remove();
        if (!this.filesEl.children.length) this.addSlot();
        this.renumber();
        this.refresh();
      });

      actions.append(replace, remove);
      body.append(name, meta, checks, actions);
      card.append(thumb, body);
      slot.append(input, kept);
      if (uploadId) slot.append(keptId);
      slot.append(card);
      this.filesEl.append(slot);
    }

    allowed(name) {
      if (!this.extensions.length) return true;
      const lower = name.toLowerCase();
      return this.extensions.some(function (ext) { return lower.endsWith(ext); });
    }

    extensionOf(name) {
      const match = String(name).toLowerCase().match(/\.[a-z0-9]+$/);
      return match ? match[0] : '';
    }

    clearSlot(slot) {
      const keep = slot.querySelector('input[type="file"]');
      this.abortUpload(slot);
      slot._ssFile = null;
      while (slot.firstChild) slot.removeChild(slot.firstChild);
      if (keep) slot.append(keep);

      /* Invalidate any in-flight content sniff for whatever file was here
         before. A stale result must never mark a replaced or removed file. */
      slot._ssContentToken = null;
      delete slot.dataset.ssPending;
      delete slot.dataset.ssUnconfirmed;
      delete slot.dataset.ssBlocked;
      slot._ssChecklistRow = null;
    }

    /*
     * The file card. Every check here is one the browser can actually make on
     * its own: the type, the size, and (for a raster image it can decode)
     * whether there are enough pixels for 300 dpi at the ordered sheet size.
     * Anything needing a server (fonts embedded, stickers detected, distance
     * from a cut line) is the merchant-settable note slot below, blank until
     * something can fill it truthfully.
     */
    fillSlot(slot, input, file) {
      this.clearSlot(slot);
      slot._ssFile = file;

      const card = document.createElement('div');
      card.className = 'ss-card ss-upload__file';

      const thumb = document.createElement('div');
      thumb.className = 'ss-upload__thumb';
      this.renderThumb(thumb, file, card);

      const body = document.createElement('div');
      body.className = 'ss-upload__file-body';

      const name = document.createElement('p');
      name.className = 'ss-upload__file-name';
      name.textContent = file.name;

      const ext = this.extensionOf(file.name);
      const meta = document.createElement('p');
      meta.className = 'ss-upload__file-meta';
      meta.textContent = this.readableSize(file.size) + ' · ' + ext.replace('.', '').toUpperCase();

      const checks = document.createElement('ul');
      checks.className = 'ss-upload__checks';
      checks.setAttribute('role', 'list');

      const actions = document.createElement('div');
      actions.className = 'ss-upload__file-actions';

      const replace = document.createElement('button');
      replace.type = 'button';
      replace.className = 'ss-upload__textlink ss-upload__textlink--accent';
      replace.textContent = this.strings.replace;
      replace.addEventListener('click', () => {
        input.removeAttribute('capture');
        input.click();
      });

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'ss-upload__textlink';
      remove.textContent = this.strings.remove;
      remove.addEventListener('click', () => {
        input.value = '';
        if (this.filesEl.children.length === 1) {
          this.renderDropzone(slot, input);
        } else {
          this.abortUpload(slot);
          slot.remove();
        }
        this.clearError();
        this.renumber();
        this.refresh();
      });

      actions.append(replace, remove);
      body.append(name, meta, checks, actions);
      card.append(thumb, body);
      slot.append(input, card);

      this.runChecks(slot, checks, file, ext);
    }

    renderThumb(thumb, file, card) {
      const ext = this.extensionOf(file.name);

      if (this.previewTypes.indexOf(ext) !== -1) {
        const url = URL.createObjectURL(file);
        this.previews.push(url);
        this.showPreview(thumb, card, url);
        return;
      }

      thumb.append(this.glyph());
    }

    /*
     * An image the browser can draw is shown large, across the card, so the
     * customer can see what they sent. The checkerboard sits on a frame the
     * size of the image itself, so it shows only through transparent pixels
     * (a cut-out reads as a cut-out) and never in the space around a photo.
     * A PDF, an AI file or an image that fails to draw keeps the small mark at
     * the side.
     */
    showPreview(thumb, card, src) {
      card.classList.add('ss-upload__file--preview');

      const frame = document.createElement('span');
      frame.className = 'ss-upload__checker';

      const image = document.createElement('img');
      image.alt = '';
      image.src = src;
      image.addEventListener('error', () => {
        card.classList.remove('ss-upload__file--preview');
        thumb.innerHTML = '';
        thumb.append(this.glyph());
      });

      frame.append(image);
      thumb.append(frame);
    }

    /* A generic document mark for the formats a browser cannot draw. */
    glyph() {
      const NS = 'http://www.w3.org/2000/svg';
      const svg = document.createElementNS(NS, 'svg');
      svg.setAttribute('class', 'ss-upload__glyph');
      svg.setAttribute('viewBox', '0 0 24 32');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('aria-hidden', 'true');

      const path = document.createElementNS(NS, 'path');
      path.setAttribute('d', 'M2 2h13l7 7v21H2z');
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '2');
      path.setAttribute('stroke-linejoin', 'round');

      const fold = document.createElementNS(NS, 'path');
      fold.setAttribute('d', 'M15 2v7h7');
      fold.setAttribute('stroke', 'currentColor');
      fold.setAttribute('stroke-width', '2');
      fold.setAttribute('stroke-linejoin', 'round');

      svg.append(path, fold);
      return svg;
    }

    /*
     * Plausible is loaded in the head by snippets/analytics.liquid, and is
     * absent by design in the theme editor and on myshopify.com previews, so
     * every call is guarded. Event names match the goals configured in the
     * Plausible dashboard; an event whose goal does not exist is received and
     * never shown, so the names must not drift from that list.
     */
    track(name, props) {
      if (typeof window.plausible !== 'function') return;
      window.plausible(name, props ? { props: props } : undefined);
    }

    /* Which boxes are still unticked, by name, so the numbers say where a
       customer gave up rather than only that they did. */
    checklistState() {
      const boxes = Array.prototype.slice.call(
        this.checklistEl.querySelectorAll('[data-ss-checklist-item]')
      );
      const unticked = boxes
        .filter(function (box) { return !box.checked; })
        .map(function (box) { return box.getAttribute('data-ss-checklist-item'); });

      return {
        ticked: String(boxes.length - unticked.length),
        stuck_on: unticked.length ? unticked.join('+') : 'none'
      };
    }

    runChecks(slot, list, file, ext) {
      const typeOk = this.allowed(file.name);
      const sizeOk = !this.maxBytes || file.size <= this.maxBytes;

      const sizeText = (sizeOk ? this.strings.checkSize : this.strings.tooBig).replace('%MB%', this.maxMb());
      list.append(this.checkRow(typeOk ? 'pass' : 'fail', typeOk ? this.strings.checkType : this.strings.badType));
      list.append(this.checkRow(sizeOk ? 'pass' : 'fail', sizeText));

      slot.dataset.ssBlocked = typeOk && sizeOk ? '' : 'blocked';

      if (this.vectorTypes.indexOf(ext) !== -1) {
        list.append(this.checkRow('pass', this.strings.checkVector));
      } else if (this.rasterTypes.indexOf(ext) !== -1) {
        this.checkResolution(list, file);
      }

      this.checkContent(slot, list, file, ext);

      /* The merchant-settable slot for anything a server would have to say. */
      const note = this.dataset.checksNote;
      if (note) list.append(this.checkRow('note', note));
    }

    /*
     * The extension check above trusts the file name, which a rename defeats
     * completely: the browser decodes and thumbnails a mislabeled file the
     * same as a correctly named one. This reads the real file signature so a
     * WebP renamed to, say, .png is still caught and named for what it is,
     * and a vector file gets its checklist whatever it is called.
     * It runs after this file's synchronous checks, so the slot is held
     * "pending" (submit stays disabled) until the read resolves.
     */
    checkContent(slot, list, file, ext) {
      const token = {};
      slot._ssContentToken = token;
      slot.dataset.ssPending = 'pending';

      this.sniffFormat(file).then((format) => {
        /* The slot moved on to a different file (replaced, removed, or
           reverted to the dropzone) while this read was in flight. */
        if (slot._ssContentToken !== token) return;

        delete slot.dataset.ssPending;

        if (format === 'webp') {
          slot.dataset.ssBlocked = 'blocked';
          list.append(this.checkRow('fail', this.strings.badWebp));
        } else if (slot.dataset.ssBlocked !== 'blocked') {
          /* The contents decide when they are recognized; the name only
             decides when they are not. */
          const needsChecklist = format
            ? this.checklistFormats.indexOf(format) !== -1
            : this.checklistTypes.indexOf(ext) !== -1;
          /* The extension is the better label of the two: an AI file and a
             PDF are the same bytes, so only the name tells them apart. */
          if (needsChecklist) {
            const label = this.checklistTypes.indexOf(ext) !== -1 ? ext.slice(1) : format;
            this.requireChecklist(slot, list, label);
          }
        }

        this.upload(slot);
        this.refresh();
      });
    }

    /* The file stays blocked, with a way back into the checklist, until the
       customer ticks every box for it. */
    requireChecklist(slot, list, fileType) {
      slot.dataset.ssUnconfirmed = 'unconfirmed';
      slot.dataset.ssVectorType = fileType || 'unknown';
      delete slot.dataset.ssAbandonSent;
      this.track('Upload: checklist shown', { file_type: slot.dataset.ssVectorType });

      const row = this.checkRow('fail', this.strings.vectorUnconfirmed);
      const review = document.createElement('button');
      review.type = 'button';
      review.className = 'ss-upload__textlink ss-upload__textlink--accent';
      review.textContent = this.strings.vectorReview;
      review.addEventListener('click', () => this.openChecklist(slot));
      row.lastElementChild.append(review);

      list.append(row);
      slot._ssChecklistRow = row;
      this.openChecklist(slot);
    }

    openChecklist(slot) {
      const dialog = this.checklistEl;
      if (!dialog || dialog.open) return;

      this.checklistSlot = slot;
      dialog.querySelectorAll('[data-ss-checklist-item]').forEach(function (box) {
        box.checked = false;
      });
      this.syncChecklist();
      dialog.showModal();
    }

    syncChecklist() {
      const boxes = Array.prototype.slice.call(this.checklistEl.querySelectorAll('[data-ss-checklist-item]'));
      this.checklistContinue.disabled = !boxes.every(function (box) { return box.checked; });
    }

    bindChecklist() {
      const dialog = this.checklistEl;
      if (!dialog) return;

      this.checklistContinue = dialog.querySelector('[data-ss-checklist-continue]');
      dialog.addEventListener('change', () => this.syncChecklist());

      this.checklistContinue.addEventListener('click', () => {
        const slot = this.checklistSlot;
        dialog.close();
        if (!slot || !slot.isConnected || !slot.dataset.ssUnconfirmed) return;

        this.track('Upload: checklist confirmed', { file_type: slot.dataset.ssVectorType || 'unknown' });
        delete slot.dataset.ssUnconfirmed;
        if (slot._ssChecklistRow) {
          slot._ssChecklistRow.replaceWith(this.checkRow('pass', this.strings.vectorConfirmed));
          slot._ssChecklistRow = null;
        }
        this.upload(slot);
        this.refresh();
      });

      /* Closing leaves the file on the card, still blocked, with Review
         checklist, Replace file and Remove all there. */
      dialog.querySelector('[data-ss-checklist-close]').addEventListener('click', () => {
        this.trackChecklistExit('Upload: checklist dismissed');
        dialog.close();
      });

      /* Straight back to the picker for the same slot, so a fixed file or a
         PNG replaces this one rather than adding a second. */
      dialog.querySelector('[data-ss-checklist-replace]').addEventListener('click', () => {
        const slot = this.checklistSlot;
        this.trackChecklistExit('Upload: checklist replace file');
        dialog.close();
        const input = slot && slot.isConnected && slot.querySelector('input[type="file"]');
        if (!input) return;
        input.removeAttribute('capture');
        input.click();
      });

      dialog.addEventListener('close', () => {
        this.checklistSlot = null;
      });

      /*
       * Leaving with a file still unconfirmed. visibilitychange is used rather
       * than beforeunload or pagehide because it is the one browsers still
       * fire reliably when a tab is closed or backgrounded on mobile. It is
       * best-effort all the same: the honest abandonment figure is "checklist
       * shown" minus "checklist confirmed", and this event only says where
       * they were stuck when they went.
       */
      this.onHide = () => {
        if (document.visibilityState !== 'hidden') return;
        this.trackAbandoned();
      };
      document.addEventListener('visibilitychange', this.onHide);
    }

    /* Both buttons that leave the checklist unfinished report the same shape. */
    trackChecklistExit(name) {
      const slot = this.checklistSlot;
      const state = this.checklistState();
      this.track(name, {
        file_type: (slot && slot.dataset.ssVectorType) || 'unknown',
        ticked: state.ticked,
        stuck_on: state.stuck_on
      });
    }

    /* One event per file, so backgrounding a tab twice is not two abandons.
       Replacing the file re-arms it, because requireChecklist clears the flag. */
    trackAbandoned() {
      const state = this.checklistState();
      Array.prototype.slice.call(this.filesEl.querySelectorAll('[data-ss-unconfirmed]'))
        .forEach((slot) => {
          if (slot.dataset.ssAbandonSent) return;
          slot.dataset.ssAbandonSent = 'sent';
          this.track('Upload: checklist abandoned', {
            file_type: slot.dataset.ssVectorType || 'unknown',
            ticked: state.ticked,
            stuck_on: state.stuck_on
          });
        });
    }

    /*
     * Identifies a file by its magic bytes rather than its name or extension.
     * WebP is a RIFF container (bytes 0-3) carrying a WEBP fourCC at bytes
     * 8-11. The two ranges have to be checked separately, since RIFF alone
     * is shared with WAV and AVI. PNG and JPEG are sniffed too, so a raster
     * renamed .pdf is not mistaken for a vector file.
     *
     * Vector formats: a PDF (and an AI saved with PDF compatibility) carries
     * %PDF- near the start, PostScript (EPS, older AI) opens with %!PS or the
     * binary EPS header C5 D0 D3 C6, and SVG is text with an <svg tag after
     * any XML declaration or comments, hence the first kilobyte rather than
     * a fixed offset.
     */
    async sniffFormat(file) {
      try {
        const buffer = await file.slice(0, 1024).arrayBuffer();
        const bytes = new Uint8Array(buffer);
        const head = String.fromCharCode.apply(null, bytes);

        if (
          bytes.length >= 12 &&
          bytes[0] === 0x52 && bytes[1] === 0x49 && bytes[2] === 0x46 && bytes[3] === 0x46 &&
          bytes[8] === 0x57 && bytes[9] === 0x45 && bytes[10] === 0x42 && bytes[11] === 0x50
        ) {
          return 'webp';
        }

        if (bytes.length >= 4 && bytes[0] === 0x89 && bytes[1] === 0x50 && bytes[2] === 0x4e && bytes[3] === 0x47) {
          return 'png';
        }

        if (bytes.length >= 3 && bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff) {
          return 'jpeg';
        }

        if (head.indexOf('%PDF-') !== -1) return 'pdf';

        if (
          head.indexOf('%!PS') === 0 ||
          (bytes.length >= 4 && bytes[0] === 0xc5 && bytes[1] === 0xd0 && bytes[2] === 0xd3 && bytes[3] === 0xc6)
        ) {
          return 'postscript';
        }

        if (/<svg[\s>]/i.test(head)) return 'svg';

        return null;
      } catch (error) {
        /* A read failure says nothing about the file's real format, so treat
           it the same as "unrecognized" rather than blocking on it. */
        return null;
      }
    }

    /*
     * Pixel dimensions against the ordered sheet at 300 dpi. Either orientation
     * counts, because a sheet laid out landscape is the same file. A format the
     * browser cannot decode says nothing at all rather than guessing.
     */
    checkResolution(list, file) {
      if (!this.configuration) return;

      const url = URL.createObjectURL(file);
      this.previews.push(url);

      const probe = new Image();
      probe.addEventListener('load', () => {
        const needW = this.configuration.widthIn * 300;
        const needH = this.configuration.heightIn * 300;
        const fits =
          (probe.naturalWidth >= needW && probe.naturalHeight >= needH) ||
          (probe.naturalWidth >= needH && probe.naturalHeight >= needW);

        list.append(
          fits
            ? this.checkRow('pass', this.strings.checkSharp.replace('%SIZE%', this.sizeLabel()))
            : this.checkRow('note', this.strings.checkLow)
        );
      });
      probe.addEventListener('error', function () {});
      probe.src = url;
    }

    checkRow(kind, text) {
      const row = document.createElement('li');
      row.className = 'ss-upload__check';
      if (kind === 'note') row.classList.add('ss-upload__check--note');
      if (kind === 'fail') row.classList.add('ss-upload__check--fail');

      const mark = document.createElement('span');
      mark.className = 'ss-upload__check-mark';
      mark.setAttribute('aria-hidden', 'true');
      mark.textContent = kind === 'pass' ? '✓' : '!';

      const label = document.createElement('span');
      label.textContent = text;

      row.append(mark, label);
      return row;
    }

    /*
     * Sends one checked file to OkayProof: a ticket through the app proxy,
     * then the bytes straight to storage with exactly the ticket's headers
     * (they are inside its signature). Only then does the slot get its two
     * hidden fields. The cart token is recorded by OkayProof, not required.
     * A file that is blocked, still being read or waiting on its checklist
     * is not sent; those paths call here again once they clear.
     */
    async upload(slot) {
      const file = slot._ssFile;
      if (!file || !slot.isConnected || slot.dataset.ssUpload) return;
      if (slot.dataset.ssBlocked === 'blocked' || slot.dataset.ssPending || slot.dataset.ssUnconfirmed) return;

      const list = slot.querySelector('.ss-upload__checks');
      const token = {};
      slot._ssUploadToken = token;
      slot.dataset.ssUpload = 'uploading';

      const row = this.checkRow('note', '');
      const status = document.createTextNode(this.strings.uploading.replace('%PERCENT%', '0%'));
      const bar = document.createElement('progress');
      bar.className = 'ss-upload__progress';
      bar.max = 100;
      bar.value = 0;
      row.lastElementChild.append(status, bar);
      if (list) list.append(row);
      this.refresh();

      const stale = () => slot._ssUploadToken !== token;
      const fail = (message) => {
        if (stale()) return;
        slot.dataset.ssUpload = 'failed';
        slot._ssXhr = null;
        row.replaceWith(this.failedRow(slot, message || this.strings.uploadFailed));
        this.refresh();
      };

      try {
        const cart = await fetch(this.root() + 'cart.js', { headers: { Accept: 'application/json' } })
          .then((response) => (response.ok ? response.json() : null))
          .catch(() => null);
        if (stale()) return;

        const response = await fetch(this.uploadProxy + '/ticket', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            filename: file.name,
            mime: this.mimeOf(file),
            bytes: file.size,
            /* An empty cart's token is a throwaway that changes on every
               read; the real one arrives with the first add. Sent only when
               it can match the order, so OkayProof logs no false mismatch. */
            cart_token: cart && cart.item_count > 0 && cart.token ? cart.token : undefined
          })
        });
        const ticket = await response.json().catch(() => ({}));
        if (stale()) return;
        /* OkayProof's refusals carry a message written for the customer. */
        if (!response.ok || !ticket.upload_id || !ticket.url) {
          fail(ticket.message);
          return;
        }

        const sent = await this.put(slot, ticket, file, (fraction) => {
          const percent = Math.round(fraction * 100);
          bar.value = percent;
          status.nodeValue = this.strings.uploading.replace('%PERCENT%', percent + '%');
        });
        if (stale()) return;
        if (!sent) {
          fail();
          return;
        }

        slot._ssXhr = null;
        slot.dataset.ssUpload = 'done';
        slot.append(this.hiddenField('data-ss-artwork', file.name), this.hiddenField('data-ss-upload-id', ticket.upload_id));
        row.replaceWith(this.checkRow('pass', this.strings.uploaded));
        this.renumber();
        this.refresh();
      } catch (error) {
        fail();
      }
    }

    /* XHR rather than fetch, for the upload progress a large file needs. */
    put(slot, ticket, file, onProgress) {
      return new Promise((resolve) => {
        const xhr = new XMLHttpRequest();
        slot._ssXhr = xhr;
        xhr.open('PUT', ticket.url);
        const headers = ticket.headers || {};
        Object.keys(headers).forEach((key) => {
          try {
            xhr.setRequestHeader(key, headers[key]);
          } catch (error) {
            /* A header the browser sets itself, such as Content-Length. */
          }
        });
        xhr.upload.addEventListener('progress', (event) => {
          if (event.lengthComputable && event.total) onProgress(event.loaded / event.total);
        });
        xhr.addEventListener('load', () => resolve(xhr.status >= 200 && xhr.status < 300));
        xhr.addEventListener('error', () => resolve(false));
        xhr.addEventListener('abort', () => resolve(false));
        xhr.send(file);
      });
    }

    /* A replaced or removed file's upload stops and its result is ignored.
       A ticket that never reaches an order is deleted by OkayProof. */
    abortUpload(slot) {
      slot._ssUploadToken = null;
      if (slot._ssXhr) slot._ssXhr.abort();
      slot._ssXhr = null;
      delete slot.dataset.ssUpload;
    }

    failedRow(slot, message) {
      const row = this.checkRow('fail', message);
      const retry = document.createElement('button');
      retry.type = 'button';
      retry.className = 'ss-upload__textlink ss-upload__textlink--accent';
      retry.textContent = this.strings.tryAgain;
      retry.addEventListener('click', () => {
        row.remove();
        delete slot.dataset.ssUpload;
        this.upload(slot);
      });
      row.lastElementChild.append(retry);
      return row;
    }

    hiddenField(marker, value) {
      const field = document.createElement('input');
      field.type = 'hidden';
      field.value = value;
      field.setAttribute(marker, '');
      return field;
    }

    mimeOf(file) {
      return this.mimeByExtension[this.extensionOf(file.name)] || file.type || 'application/octet-stream';
    }

    /*
     * Property names have to stay contiguous, or an order shows Artwork 1 and
     * Artwork 3 with nothing between them, so only slots with something to
     * post take a number. Each file's name and upload id share it: OkayProof
     * pairs "Artwork 2" with "_upload_id 2". A kept link from before
     * OkayProof has no id and posts alone.
     */
    renumber() {
      let number = 0;
      Array.prototype.forEach.call(this.filesEl.children, (slot) => {
        const input = slot.querySelector('input[type="file"]');
        if (input) input.removeAttribute('name');

        const nameField = slot.querySelector('[data-ss-kept], [data-ss-artwork]');
        const idField = slot.querySelector('[data-ss-kept-id], [data-ss-upload-id]');
        if (!nameField) return;

        number += 1;
        nameField.name = 'properties[' + this.namePrefix + ' ' + number + ']';
        if (idField) idField.name = 'properties[_upload_id ' + number + ']';
      });
    }

    countFiles() {
      return Array.prototype.filter.call(this.filesEl.children, (slot) => this.filled(slot)).length;
    }

    /* Every new file has finished uploading. Kept files were sent before. */
    uploadsDone() {
      return Array.prototype.every.call(this.filesEl.children, (slot) => {
        return !slot._ssFile || slot.dataset.ssUpload === 'done';
      });
    }

    /* A vector file waiting on its checklist, or a failed upload, counts as
       blocked too. */
    blocked() {
      return !!this.filesEl.querySelector('[data-ss-blocked="blocked"], [data-ss-unconfirmed], [data-ss-upload="failed"]');
    }

    /* True while a content sniff is still reading a file or a file is still
       uploading. Submit stays disabled for these too. */
    pending() {
      return !!this.filesEl.querySelector('[data-ss-pending="pending"], [data-ss-upload="uploading"]');
    }

    refresh() {
      const chosen = this.countFiles();
      const slots = this.filesEl.children.length;
      const allFilled = chosen === slots;
      const ready =
        this.later || (chosen >= 1 && !this.blocked() && !this.pending() && this.uploadsDone());

      this.submitBtn.disabled = !ready;
      if (this.stickyBtn) this.stickyBtn.disabled = !ready;
      /* Not beside a PDF, AI or EPS layout, which goes alone. */
      const layout = Array.prototype.some.call(this.filesEl.children, (slot) => {
        return this.layoutTypes.indexOf(this.extensionOf(this.slotFileName(slot))) !== -1;
      });
      this.addRow.hidden = this.later || layout || !(chosen >= 1 && allFilled && slots < this.maxFiles);
      /* Offered only while no file is chosen: once there is one, it is the
         answer. */
      if (this.laterOfferEl) this.laterOfferEl.hidden = this.later || chosen > 0;

      this.applyStateCopy(chosen);
    }

    /* The heading is server-rendered from the setting; only the promise under
       it changes, to the editing line when a cart line is being edited. */
    applyStateCopy(chosen) {
      if (this.leadEl) this.leadEl.textContent = this.editKey && chosen > 0
        ? this.strings.editing
        : this.strings.leadEmpty;
    }

    showError(message) {
      this.errorEl.textContent = message;
      this.errorEl.hidden = false;
    }

    clearError() {
      this.errorEl.textContent = '';
      this.errorEl.hidden = true;
    }

    readableSize(bytes) {
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1048576) return (bytes / 1024).toFixed(0) + ' KB';
      return (bytes / 1048576).toFixed(1) + ' MB';
    }

    /* 5 and 7 read as 5" x 7"; 6.5 keeps its half. */
    trim(value) {
      return String(Math.round(Number(value) * 100) / 100);
    }

    sizeLabel() {
      if (!this.configuration) return '';
      return this.trim(this.configuration.widthIn) + '" x ' + this.trim(this.configuration.heightIn) + '"';
    }

    money(cents) {
      const parts = (cents / 100).toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return this.currency + parts[0] + '.' + parts[1];
    }

    productUrl() {
      return this.root() + 'products/' + this.handle + '.js';
    }

    /* The summary is confirmed against the store, not reconstructed from the
       URL, so it can never advertise a price the cart will not honor. */
    loadSummary() {
      fetch(this.productUrl())
        .then((response) => (response.ok ? response.json() : null))
        .then((product) => {
          if (!product || !product.variants) return;

          const wanted = String(this.variantId);
          const variant = product.variants.filter(function (item) {
            return String(item.id) === wanted;
          })[0];
          if (!variant) return;

          /*
           * The rows are filled from the variant's options by name. A row the
           * product has no option for (the Gift Tag Sheet has Quantity only)
           * is hidden rather than left empty.
           */
          const names = (product.options || []).map(function (option) {
            return typeof option === 'string' ? option : option.name;
          });
          const values = variant.options || [];
          const rows = { Size: '[data-ss-summary-size]', Finish: '[data-ss-summary-finish]', Quantity: '[data-ss-summary-quantity]' };
          Object.keys(rows).forEach((name) => {
            const index = names.indexOf(name);
            const value = index === -1 ? '' : values[index] || '';
            this.setText(rows[name], value);
            const node = this.querySelector(rows[name]);
            const row = node && node.closest('.ss-upload__row');
            if (row) row.hidden = value === '';
          });

          /* A product tagged free-shipping ships free at any total, through
             its own shipping profile, so the threshold note would be wrong. */
          if ((product.tags || []).indexOf('free-shipping') !== -1) {
            this.setText('.ss-upload__summary .ss-upload__shipping', this.dataset.tFreeShipping || '');
          }

          this.setText('[data-ss-summary-price]', this.money(variant.price));
          this.setText('[data-ss-sticky-total]', this.money(variant.price));
          this.setText('[data-ss-sticky-echo]', (variant.options || []).join(' · '));
          this.summaryEl.hidden = false;
        })
        .catch(function () {
          /* A summary we cannot confirm is simply not shown. */
        });
    }
  }

  if (!customElements.get('upload-artwork')) {
    customElements.define('upload-artwork', UploadArtwork);
  }

  } catch(e) { console.error(e); }
})();
})();
